class UnauthorizedController {
  constructor(authService, $stateParams) {
    "ngInject";

    this.authService = authService;
    this.$stateParams = $stateParams;
  }
}

export default UnauthorizedController;



// WEBPACK FOOTER //
// ./client/app/components/unauthorized/unauthorized.controller.js